import { Box, Chip, Typography } from '@mui/material';
import type { MedNecCaseView } from '../../../services/MedNecService';

export const patientTemplate = (row: MedNecCaseView) => (
  <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.75 }}>
    <Typography variant="body2" sx={{ fontWeight: 500 }}>
      {row.patient ? `${row.patient.lastName}, ${row.patient.firstName}` : '—'}
    </Typography>
    {row.isDirectAdmit && (
      <Chip
        label="DA"
        size="small"
        color="error"
        variant="outlined"
        sx={{ height: 20, fontSize: '0.7rem', fontWeight: 700 }}
        title="Direct Admit"
      />
    )}
  </Box>
);

export const memberIdTemplate = (row: MedNecCaseView) => (
  <Typography variant="body2">{row.patient?.memberId || '—'}</Typography>
);

export const cptTemplate = (row: MedNecCaseView) => (
  <Typography variant="body2">{row.cptCodes?.join(', ') || '—'}</Typography>
);

export const dateTemplate = (row: MedNecCaseView) => (
  <Typography variant="body2">
    {row.createdAt ? new Date(row.createdAt).toLocaleDateString() : '—'}
  </Typography>
);

export const docsTemplate = (row: MedNecCaseView) => (
  <Typography variant="body2" sx={{ textAlign: 'center' }}>
    {row.documentCount}
  </Typography>
);
